import React from "react";
import PropTypes from "prop-types";
import styles from "./SettingsMenuList.css";

export const SettingsMenuList = ({ children, ...props }) => (
  <div className={styles.list} {...props}>
    {children}
  </div>
);

SettingsMenuList.propTypes = {
  children: PropTypes.node.isRequired,
};
